import SearchTemplate from './SearchTemplate';

export { type SearchTemplateProps } from './SearchTemplate';
export default SearchTemplate;
